import { Component } from '@angular/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';
import { DIC } from '../../../../dic';
import { GN } from '../../../../../gn';

/**
 * Generated class for the OrderpriorityPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-orderpriority',
  templateUrl: 'orderpriority.html',
})
export class OrderpriorityPage {
  drn: any;
  _plow = false
  _pmedium = false
  _phigh = false

  constructor(public toastCtrl: ToastController, public dic: DIC, public gn: GN, public navCtrl: NavController, public navParams: NavParams) {
    this.drn = this.navParams.get('drn')
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad OrderpriorityPage');

    if (this.drn.priority == 1) this._plow = true; //low
    if (this.drn.priority == 2) this._pmedium = true; //medium
    if (this.drn.priority == 3) this._phigh = true; //high
  }

  setpriority(ev: any, _type) {
    var _that = this
    var _ch = ev.value;

    if (_type == 1 && _ch) {
      this._pmedium = false;
      this._phigh = false;
    }
    if (_type == 2 && _ch) {
      this._plow = false;
      this._phigh = false;
    }
    if (_type == 3 && _ch) {
      this._plow = false;
      this._pmedium = false;
    }
  }

  savePriority() {
    var _that = this

    var _p = 0
    if (_that._plow)
      _p = 1;
    if (_that._pmedium)
      _p = 2;
    if (_that._phigh)
      _p = 3;

    this.gn._Post('/api/gn/setpriority', { priority: this.gn.crypt(_p), orderid: this.gn.crypt(this.drn.id) }, function (_data) {
      _that.navCtrl.pop()

      var cb = _that.navParams.get('cb')
      cb();

      _that.drn.priority = _p

      const toast = _that.toastCtrl.create({ message: _that.dic.l["succsaved1"], duration: 3000, position: 'top' });
      toast.present();
      return
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/routing/routeindoor/manageorders/orderpriority/orderpriority.ts